import theme from '../../../js/shared/new-theme';

const palette = theme.palette;

const alertColorMatrix = {
    info: {
        background: palette.common.white,
        iconBackground: palette.blue[500].value,
        color: palette.blue[500].value
    },
    warning: {
        background: palette.yellow[100].value,
        iconBackground: palette.yellow[600].value,
        color: palette.yellow[600].value
    },
    danger: {
        background: palette.red[100].value,
        iconBackground: palette.red[500].value,
        color: palette.red[500].value
    },
    success: {
        background: palette.green[100].value,
        iconBackground: palette.green[700].value,
        color: palette.green[700].value
    },
    outline: {
        background: palette.common.white,
        color: "inherit"
    }
};

export const defaultStyle = (type, hasIcon) => {
    const isOutline = type === "outline";
    const { color, background, iconBackground } = alertColorMatrix[type || "info"];

    return `
	> div {
		border: ${isOutline ? `1px solid ${palette.yellow[500].value}` : "none"};
		border-radius: 4px;
		background-color: ${background};
		color: ${color};
		${hasIcon
            ? `> div:first-of-type { 
				background-color: ${iconBackground};
				i {
					color: ${palette.common.white};
					:before {
					color: ${palette.common.white};
					}
				}
			}`
            : ""
        }
	}
	
`;
};
